export const incidentInfoActions = {
  handleClaimIncidentDate: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimIncidentDate", payload);
  },
  handleClaimLossType: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimLossType", payload);
  },
  handleClaimLawEnforcementName: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimLawEnforcementName", payload);
  },
  handleClaimFiledReport: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimFiledReport", payload);
  }
};
